import { QueryClient } from '@tanstack/react-query';

/**
 * Cliente de consultas do TanStack Query.
 *
 * Listagem sempre pagina no servidor, entao o cache guarda pagina, nao colecao
 * inteira (CLAUDE.md, "Regras de API", item 6).
 *
 * Fica fora de App.tsx de proposito: arquivo de componente que tambem exporta
 * valor perde a recarga rapida do Vite.
 */
export const clienteConsultas = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
